import React, { useState, useEffect } from "react";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import { Link, useParams } from "react-router-dom";
import image0 from "../assets/images/Artwork-Specific-Edition-Page-Auction/0.png";
import image1 from "../assets/images/Artwork-Specific-Edition-Page-Auction/1.png";
import image2 from "../assets/images/Artwork-Specific-Edition-Page-Auction/2.png";
import image3 from "../assets/images/Artwork-Specific-Edition-Page-Auction/3.png";
import image4 from "../assets/images/Artwork-Specific-Edition-Page-Auction/4.png";
import itemImg from "../assets/images/place-a-bid/artwork.png";
import ownerIcon from "../assets/images/place-a-bid/owner-profile-pic.png";
import Header from "./Header";
import axios from "axios";
import { getItemData, bid } from "../blockchain/functions/functions";
import Collection from "./Collection";

const PlaceBid = ({ props }) => {
  let { collection, address, id } = useParams();
  const [bidAmount, setBidAmount] = useState("");
  const [itemData, setItemData] = useState({
    isAuction: false,
    price: "0",
    supply: 0,
    currentSupply: 0,
    highBid: "",
    smallBid: "",
    indexSmall: "",
    bids: [],
  });
  const [collectionData, setCollectionData] = useState({
    name: "",
    description: "",
    image: "",
    items: [],
  });

  const handleBid = async () => {
    let receipt = await bid(id, itemData.indexSmall, address, bidAmount);
    if (receipt) {
      console.log(receipt);
      getData();
    }
  };

  const getData = async () => {
    if (address) {
      let newData = await getItemData(id, address);
      setItemData(newData);
      console.log(newData);
    }
  };

  const getCollectionDetails = async () => {
    console.log(collection);
    if (collection) {
      let details = await axios.get(
        `https://nfttest.xyz/nftapi/index.php/home/get_collections/${collection}`
      );

      console.log(details.data);

      setCollectionData(details.data);
    }
  };

  useEffect(() => {
    getCollectionDetails();
    getData();
  }, []);

  return (
    <div className="main-wrapper">
      {/* Header area start */}
      <Header />
      {/* Header area end */}

      {/* Bid area start */}

      <div className="container-fluid mb-5 bid-area">
        <div className="row">
          <div className="col-lg-2 col-sm-0"></div>
          <div className="col-lg-2 place">
            <h3>Place A Bid</h3>
            <img
              src={`https://nfttest.xyz/nftapi/${collectionData?.items[id]?.images}`}
              alt=""
              width="100%"
            />
          </div>
          <div className="col-lg-6 place1">
            <h3>
              {collectionData?.items[id]?.item_title}
              <span>
                Owned by <Link to="#">NFTYbuyer1</Link>
                <img src={ownerIcon} alt="" />
              </span>
            </h3>
            <hr />
            <p>
              {address}
              <span>28200050006</span>
            </p>
            <p>
              Contract Address
              <span>Token ID </span>
            </p>
            <h4>
              {itemData.highBid / 10 ** 18} ETH
              <br />
              Highest Bid
            </h4>
          </div>
          <div className="col-lg-2 "></div>
        </div>
        <div className="row">
          <div className="col-lg-2 col-sm-0 "></div>
          <div className="col-lg-8 bid ">
            <h1>Bid</h1>
            <p>
              Minimum:{" "}
              {itemData.smallBid == "0"
                ? Number(itemData.price) / 10 ** 18
                : (Number(itemData.smallBid) + Number(itemData.step)) /
                  10 ** 18}
              ETH
            </p>
            <input
              value={bidAmount}
              onChange={(e) => setBidAmount(e.target.value)}
              type="number"
              className="bid-rate"
            />
            <br />
            <button onClick={handleBid} type="button">
              Place BID
            </button>
            <div className="details">
              <h3>Current Bids</h3>
              <h5>{itemData.supply} items available</h5>
              <ul>
                {itemData.bids
                  .sort(function (a, b) {
                    return b - a;
                  })
                  .map((bid) => {
                    return <li>{bid / 10 ** 18}</li>;
                  })}
              </ul>
            </div>

            <div className="details">
              <h3>Auction Details</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                diam nonummy nibh euismod tincidunt ut laoreet dolore magna
                aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                aliquip ex ea commodo consequat. Duis autem vel eum{" "}
              </p>
            </div>
            <div className="row justify-content-center"></div>
            <Link to={`/SpecificItem/${collection}/${address}/${id}`}>
              <button
                // onClick={() => handleBuy(index, item.price)}
                style={{ width: "120px" }}
                className="buy-button"
              >
                Go back
              </button>
            </Link>
          </div>
          <div className="col-lg-2 col-sm-0"></div>
        </div>
        {/* Bid area end */}
      </div>
    </div>
  );
};

export default PlaceBid;
